import { PriceType } from '../types';

export function hasSubscription(type: PriceType): boolean {
  return type === 'balance_subscription' || type === 'access_subscription';
}

export function hasBalance(type: PriceType): boolean {
  return type === 'balance_subscription' || type === 'product' || type === 'certificate';
}
